<template>
    <div>

        <b-table

                :data="isEmpty ? [] : datasetToDisplay"
                bordered
                striped
                narrowed
                hoverable
                focusable
                mobile-cards>


            <b-table-column   label="ID"  v-slot="props" >
                <b-button type="is-success" outlined @click="showLab(props.row.idlab,props.row.kind,props.row.idopd)">{{ props.row.idlab }}</b-button>
            </b-table-column>
            <b-table-column   label="OPD No." v-slot="props"  >
                {{ props.row.idopd }}
            </b-table-column>
            <b-table-column   label="Pet Name"  v-slot="props" >
                {{ props.row.opdname }}
            </b-table-column>
            <b-table-column   label="Owner"  v-slot="props" >
                {{ props.row.owner_name }}
            </b-table-column>
            <b-table-column   label="Gender" v-slot="props" >
                                      <span >
                                       <b-icon pack="fas" type="is-text"
                                               :icon="props.row.sex === 'M' ? 'mars' : 'venus'">
                                       </b-icon>
                                      </span>

            </b-table-column>
            <b-table-column   label="Breed"  v-slot="props" >
                {{ props.row.breedname }}
            </b-table-column>
            <b-table-column   label="speciesname" v-slot="props"  >
                {{ props.row.speciesname }}
            </b-table-column>
            <b-table-column   label="Req. by" v-slot="props" >

                <!--                                    <figure class="image is-32x32" >-->
                <!--                                        <img :src="transFromAvartar( props.row.avartar_user_req , props.row.iduser_req) " />-->
                <!--                                    </figure>-->
                {{ props.row.user_req }}

            </b-table-column>
            <b-table-column   label="Date Req." v-slot="props"  >
                {{ props.row.date_req }}   {{ props.row.time_req }}
            </b-table-column>
            <b-table-column   label="Publish by" v-slot="props" >
                <!--                                    <figure class="image is-32x32" >-->
                <!--                                        <img :src="transFromAvartar( props.row.avartar_user_resulted , props.row.iduser_resulted) " />-->
                <!--                                    </figure>-->
                {{ props.row.user_resulted }}

            </b-table-column>
            <b-table-column   label="Date Publish" v-slot="props" >
                {{ props.row.date_resulted }} {{ props.row.time_resulted }}
            </b-table-column>



            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                    icon="emoticon-sad"
                                    size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>


            <template slot="footer"  >
                <div class="box">
                    <div  class="level-right" >
                        <b-button type="is-primary" outlined v-show="datasetToDisplay.length>0"
                                  :disabled="isDisableMoreBtn"
                                  :loading="isMoreBtnLoading"
                                  @click="$emit('loadDataMore')" >More..</b-button></div>
                </div>
            </template>


        </b-table>
    </div>
</template>

<script>
    export default {
        name: "HomeEachKind",
        props:{
            datasetToDisplay : Array,
            isDisableMoreBtn : Boolean,
            isMoreBtnLoading : Boolean
        },
        data(){
            return {
                isEmpty : false,
            }
        },
        methods:{
            showLab(idlab,kind,idopd){
                this.$emit('showLab',{ "idlab": idlab, "kind":kind, "idopd" : idopd})
            }
        }
    }
</script>

<style scoped>

</style>